import { render, staticRenderFns } from "./leaveBalances.vue?vue&type=template&id=34a58706"
import script from "./leaveBalances.vue?vue&type=script&lang=js"
export * from "./leaveBalances.vue?vue&type=script&lang=js"
import style0 from "./leaveBalances.vue?vue&type=style&index=0&id=34a58706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports